import { EvaluationStatus, EvaluationStatusTab } from '@/contexts/campaigns/Campaigns.interfaces'
import { NdsTagColor } from '@/components/NewDesignSystem/NdsTag/NdsTag.interfaces'
import { NdsIconType } from '@/components/NewDesignSystem/NdsIcon/NdsIcon.interfaces'
import { NdsColor } from '@/interfaces/NdsColors.interfaces'

export const CAMPAIGN_RESULTS_ROUTE = 'gcampaign_details'

export const EVALUATION_REVIEW_STATUS_TRANSLATION_KEY: Readonly<Record<EvaluationStatus, string>> = {
  [EvaluationStatus.APPROVED]: 'campaigns.evaluations.review.status.approved',
  [EvaluationStatus.PENDING_APPROVAL]: 'campaigns.evaluations.review.status.to_review',
  [EvaluationStatus.CHALLENGED]: 'campaigns.evaluations.review.status.rejected',
}

export const EVALUATION_REVIEW_STATUS_TAG_COLOR: Readonly<Record<EvaluationStatus, NdsTagColor>> = {
  [EvaluationStatus.APPROVED]: NdsTagColor.SUCCESS,
  [EvaluationStatus.PENDING_APPROVAL]: NdsTagColor.PRIMARY_100,
  [EvaluationStatus.CHALLENGED]: NdsTagColor.DANGER,
}

export const EVALUATION_REVIEW_STATUS_ICON: Readonly<Record<EvaluationStatus, NdsIconType>> = {
  [EvaluationStatus.APPROVED]: NdsIconType.CHECK,
  [EvaluationStatus.PENDING_APPROVAL]: NdsIconType.CIRCLE_DOT_DASHED,
  [EvaluationStatus.CHALLENGED]: NdsIconType.CLOSE,
}

export const EVALUATION_REVIEW_ICON_COLOR: Readonly<Record<EvaluationStatus, NdsColor>> = {
  [EvaluationStatus.APPROVED]: NdsColor.SUCCESS_500,
  [EvaluationStatus.PENDING_APPROVAL]: NdsColor.PRIMARY_500,
  [EvaluationStatus.CHALLENGED]: NdsColor.DANGER_500,
}

export const EVALUATION_STATUS_TABS = {
  ...EvaluationStatusTab,
}

export const EVALUATION_STATUS_TABS_TRANSLATION_KEY: Readonly<Record<EvaluationStatusTab, string>> = {
  [EVALUATION_STATUS_TABS.IN_PROGRESS]: 'campaigns.evaluations.status_tab.in_progress',
  [EVALUATION_STATUS_TABS.SUBMITTED]: 'campaigns.evaluations.status_tab.submitted',
  [EVALUATION_STATUS_TABS.VALIDATED]: 'campaigns.evaluations.status_tab.validated',
}
